import { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LocalShipping } from "@mui/icons-material";
import logoArcese from "../../assets/images/arcese_logo_text_red.svg";

const ErrorPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/"); // 🔄 Reindirizza alla dashboard
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 3,
        bgcolor: "background.default",
        gap: 2,
        position: "relative",
      }}
    >
      {/* Titolo */}
      <Typography variant="h5" fontWeight="bold" color="error">
        Errore
      </Typography>

      {/* Testo descrittivo */}
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: "400px", lineHeight: 1.6 }}
      >
        Il viaggio selezionato è precedente alla data di attivazione del profilo
        aziendale.
      </Typography>

      {/* Countdown */}
      <Typography variant="body1" fontWeight="medium" sx={{color:'#333333'}}>
        Reindirizzamento in {countdown} secondi...
      </Typography>

      {/* Animazione furgoncino */}
      <motion.div
        animate={{ x: [-100, 200] }} // Si muove solo in avanti
        transition={{ duration: 5, ease: "easeInOut" }} // Movimento sincronizzato con il countdown
        style={{ marginTop: "16px" }}
      >
        <LocalShipping sx={{ fontSize: 48, color: "#333333" }} />
      </motion.div>

      {/* Pulsante */}
     {/*  <Button
        variant="contained"
        sx={{
          mt: 2,
          backgroundColor: "error.main",
          "&:hover": {
            backgroundColor: "error.dark",
            transform: "scale(1.05)",
          },
          transition: "all 0.3s ease",
          px: 4,
          py: 1,
          borderRadius: "8px",
        }}
        onClick={() => navigate("/")}
      >
        Torna alla Dashboard
      </Button> */}

      {/* Logo in basso */}
      <Box sx={{width:'100%',display:'flex',justifyContent:'center',alignItems:'center', paddingLeft:'100px'}}>
        <img
          src={logoArcese}
          alt="Arcese Logo"
          style={{
            height: "60px",
            alignSelf:'center',
          }}
        />
      </Box>
    </Box>
  );
};

export default ErrorPage;
